import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux'
import { fetch } from '../../actions'
import { useFetchPostV2, useSavePost } from '../../components/Hooks/Conexao'
import Spinner from '../../components/Spinner/Spinner'
import Menu from '../Shared/Menu'
import ModalDetalhe from '../../components/ModalDetalhe';
import SelectBasico from '../../components/SelectBasico';
import { Tabs, Input, Button, Icon, Modal, Drawer, Select, Divider, DatePicker, Popover } from 'antd'
import { LoadingScreen, SubTitulo, IconCheck, Tag, BtnConfirm } from '../../components/Diversos';
import CliDet from './ClienteDetalhe';
import moment from 'moment'
import DtPicker from '../../components/DtPicker';

const culture = new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
const TabPane = Tabs.TabPane;
const { Option } = Select;
const { TextArea } = Input;

function Func(props) {
    const [filtros, setFiltros] = useState({ status: 'ativos' })
    const [dadosIni, listarIni, loadingIni] = useFetchPostV2(props.fetch, '/cliente', { modelo: 'clientes-ini', dados: filtros })
    const [dados, listar, loading] = useFetchPostV2(props.fetch, '/cliente', { modelo: 'clientes', dados: filtros })
    const [detId, setDetId] = useState(null);

    useEffect(() => listarIni(), []);

    useEffect(() => {
        if(!!dadosIni){
            listar();
        }
    }, [dadosIni]);

        const contentOpcoes = (
        <div style={{ padding: 20 }}> 
            <div style={{ marginBottom: 15 }}>
                <div style={{ marginBottom: 5 }}><SubTitulo>Vencimento Certificado</SubTitulo></div>
                <DtPicker value={filtros.certificadoVencIni} onChange={d => setFiltros({...filtros,certificadoVencIni: d })} />
                   &nbsp;  até &nbsp;
                <DtPicker value={filtros.certificadoVencFim} onChange={d => setFiltros({...filtros,certificadoVencFim: d })} />
            </div>
  
        </div>
    );

    return (
        <>
            <Menu />
            <div style={{ textAlign: 'center', marginTop: 15 }}><h2>Clientes</h2></div>
            <div style={{ backgroundColor: '#eee', padding: 15, display: 'flex' }}>
                <div>
                    <SubTitulo>Status</SubTitulo><br />
                    <Select style={{ width: 200 }} value={filtros.status} onChange={v => setFiltros({ ...filtros, status: v })}>
                        <Option value="ativos">Ativos</Option>
                        <Option value="inativos">Inativos</Option>
                        <Option value="todos">Todos</Option>
                    </Select>
                </div>
                {(!!dadosIni && dadosIni.tags) && (
                    <div style={{marginLeft: 8, width: 300}}>
                        <SubTitulo>Marcações</SubTitulo>
                        <SelectBasico style={{  }} idProp={filtros.tags} dados={dadosIni.tags} onChange={v => setFiltros({ ...filtros, tags: v })} mode="multiple" />
                    </div> 
                )}
                <div style={{marginLeft: 7}}>
                    <div><SubTitulo>&nbsp;</SubTitulo></div>
                    <Popover content={contentOpcoes} trigger="hover" placement="bottom" className="hidden-xs">
                        <Button style={{ marginRight: 10 }}>
                            <Icon type="down" />
                        </Button>
                    </Popover>
                </div>
                <div style={{marginLeft: 8}}>
                    <br/>
                    <Button type="primary"  onClick={listar}>Listar</Button>
                </div>
            </div>
            {/* <pre>{JSON.stringify(filtros, null, 2)}</pre> */}
            {(loading || loadingIni) && <div style={{ marginTop: 40 }}><Spinner /></div>}
            {(!loading && !loadingIni && dados) && (<div className="tabela-wrapper" style={{ marginBottom: 20 }}>
                <table className="tabela-padrao">
                    <thead>
                        <tr>
                            <th></th>
                            <th className="text-left">Nome ({(dados || []).length})</th>
                            <th>Marcações</th>
                            <th>Obs</th>
                            <th className="text-center">Data Cadastro</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(dados || []).map(v => {
                            return (
                                <tr key={v.id} style={{ cursor: 'pointer' }} onClick={() => setDetId(v.id)}>
                                    <td><IconCheck ativo={v.ativa} /></td>
                                    <td className="text-left">{v.nome ? v.nome : 'NOVO CADASTRO'}</td>
                                    <td style={{minWidth: 210}}>{(v.tags || '').split(';').map(t => <Tag key={t} style={{ marginRight: 4 }} className="divTag divTagSm">{t}</Tag>)}</td>
                                    <td style={{ maxWidth: 500, overflowX: 'hidden', whiteSpace: 'nowrap' }}>{v.obs}</td>
                                    <td className="text-center">{moment(v.dataCadastro).format('DD/MM/YYYY')}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            )}

            <ModalDetalhe
                WrappedDet={CliDet}
                url='cliente'
                modelo='cli-det'
                id={detId}
                onCancel={() => setDetId(null)}
                onSave={() => { setDetId(null); listar(); }}
                width={800}
            />
        </>
    )
}

const mapStateToProps = (state) => {
    return { userRole: state.auth.role  };
  };

export default connect(mapStateToProps, { fetch })(Func);